import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

export default css`
  .autolist-button {
    width: 100%;
    display: block;
  }

  @media (min-width: ${screen.mdMin}) {
    .submit-review-container {
      width: 195px;
    }
  }

  .content {
    display: none;
    font-size: 15px;
    font-weight: 900;
    margin-bottom: 15px;
    text-align: center;
  }

  @media (min-width: ${screen.mdMin}) {
    .content {
      display: block;
    }
  }
`;
